var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1893_14377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.50789 0H11.6746C12.337 0.00197841 12.9717 0.266006 13.4401 0.734419C13.9086 1.20283 14.1726 1.83757 14.1746 2.5V7.5H6.67456C6.01152 7.5 5.37563 7.76339 4.90679 8.23223C4.43795 8.70107 4.17456 9.33696 4.17456 10C4.17456 10.663 4.43795 11.2989 4.90679 11.7678C5.37563 12.2366 6.01152 12.5 6.67456 12.5H14.1746V17.5C14.1726 18.1624 13.9086 18.7972 13.4401 19.2656C12.9717 19.734 12.337 19.998 11.6746 20H2.50789C1.84546 19.998 1.21072 19.734 0.742311 19.2656C0.273899 18.7972 0.00987148 18.1624 0.00789356 17.5V2.5C0.00987148 1.83757 0.273899 1.20283 0.742311 0.734419C1.21072 0.266006 1.84546 0.00197841 2.50789 0Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1664 10.8332H6.67475C6.45374 10.8332 6.24178 10.7454 6.0855 10.5891C5.92922 10.4328 5.84142 10.2208 5.84142 9.99983C5.84142 9.77882 5.92922 9.56685 6.0855 9.41057C6.24178 9.25429 6.45374 9.1665 6.67475 9.1665H17.1664L16.0831 8.0915C15.9262 7.93458 15.838 7.72175 15.838 7.49983C15.838 7.27791 15.9262 7.06508 16.0831 6.90816C16.24 6.75124 16.4528 6.66309 16.6748 6.66309C16.8967 6.66309 17.1095 6.75124 17.2664 6.90816L19.7664 9.40816C19.9169 9.5684 20.0007 9.77998 20.0007 9.99983C20.0007 10.2197 19.9169 10.4313 19.7664 10.5915L17.2664 13.0915C17.1068 13.2433 16.895 13.328 16.6748 13.328C16.4545 13.328 16.2427 13.2433 16.0831 13.0915C15.927 12.9342 15.8393 12.7215 15.8393 12.4998C15.8393 12.2782 15.927 12.0655 16.0831 11.9082L17.1664 10.8332Z",
    fill: "#6B6B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1893_14377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d0b881cc7b382eceeb1eb579a5b630e8.svg";
export { ForwardRef as ReactComponent };